module.exports = __webpack_public_path__ + "media/images/brands/marque-revlon-5158470b7984a325f30e624e3c2e5a05.jpg";